var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEndlessBenefit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.134 19.35c-1.2-.134-2.534-.134-4-.134-10.8.4-17.6 6.4-19.067 7.867-1.6-1.467-8.4-7.467-19.067-7.867-12.133-.4-20 6.667-21.333 7.867v58.933c11.867-4.666 30.4-8 46.267-.533 11.466-5.467 23.6-5.867 34.666-2.8v-55.6c-1.2-1.067-7.6-6.8-17.466-7.733z",
    fill: "#0C0A0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.333 76.816c-4-1.6-10.266-3.466-18.266-3.866-10-.4-17.867 2.133-22.267 3.866V17.883c1.6-1.467 8.4-7.467 19.067-7.867 12.133-.4 20 6.667 21.333 7.867.133 19.733.133 39.333.133 58.933z",
    fill: "#A9F4F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.533 76.816c4-1.6 10.267-3.466 18.267-3.866 10-.4 17.866 2.133 22.266 3.866V17.883c-1.6-1.467-8.4-7.467-19.066-7.867-12.134-.4-20 6.667-21.334 7.867-.133 19.733-.133 39.333-.133 58.933z",
    fill: "#A9F4F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.267 35.216c2.4-1.333 7.6-4 14.8-3.867 6.666.134 11.6 2.534 14 3.867M16.267 45.35c2.4-1.334 7.6-4 14.8-3.867 6.666.133 11.6 2.533 14 3.867M16.267 55.616c2.4-1.333 7.6-4 14.8-3.866 6.666.133 11.6 2.533 14 3.866M16.267 65.75c2.4-1.334 7.6-4 14.8-3.867 6.666.133 11.6 2.533 14 3.867M16.267 24.95c11.2-10.934 14.666 0 27.066 0M56.8 24.95c2.4-1.334 7.6-4 14.8-3.867 6.666.133 11.6 2.533 14 3.867M56.8 35.216c2.4-1.333 7.6-4 14.8-3.867 6.666.134 11.6 2.534 14 3.867M56.8 45.35c2.4-1.334 7.6-4 14.8-3.867 6.666.133 11.6 2.533 14 3.867M56.8 55.616c2.4-1.333 7.6-4 14.8-3.866 6.666.133 11.6 2.533 14 3.866M50.934 18.55v57.6M90.666 66.15c-3.2-.267-6.4-1.2-9.466-2.534 0 4.4-.134 7.334-1.334 9.467",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgEndlessBenefit;